// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"_797aeb","row":"_06549a","card":"_96a251","content":"_1e670a","homepageHeadline":"_524d7b","container":"_73bdbf"};